import { render, staticRenderFns } from "./LengthMarker.vue?vue&type=template&id=5197853a&scoped=true"
import script from "./LengthMarker.vue?vue&type=script&lang=js"
export * from "./LengthMarker.vue?vue&type=script&lang=js"
import style0 from "./LengthMarker.vue?vue&type=style&index=0&id=5197853a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197853a",
  null
  
)

export default component.exports